import { useMatch } from "react-router-dom";

// The page owns its own route identity, so the console layout does not have to
// hand-roll a comparison against a string it does not control.
export const ELI_CHAT_PATH = "/console/eli-chat";

/**
 * True when the Eli full page is the route being rendered, which is when the
 * floating bubble must be hidden.
 *
 * useMatch rather than a comparison against location.pathname. The previous two
 * attempts both leaked, because normalising a URL by hand means reimplementing
 * whatever the router already does:
 *
 *   pathname !== ELI_CHAT_PATH                     leaked "/console/eli-chat/"
 *   pathname.replace(/\/+$/, "") !== ELI_CHAT_PATH  leaked "/console/ELI-CHAT"
 *
 * Both are routes react-router actually serves this page at: compilePath builds
 * its regex with the "i" flag because caseSensitive defaults to false, and it
 * tolerates a trailing slash. Asking the router settles slash and case together,
 * and stays correct if those defaults ever change.
 */
export const useOnEliChatPage = () => useMatch(ELI_CHAT_PATH) !== null;

export default useOnEliChatPage;
